import { useState } from 'react';
import Button from '../base/Button';

export default function GalleryShowcase() {
  const [selectedImage, setSelectedImage] = useState(0);

  const showcaseItems = [
    {
      id: 1,
      title: '艺术工坊',
      subtitle: '匠心独运的创作空间',
      description: '在这里，每一件珠宝都经过精心设计和手工制作，融合传统工艺与现代美学。',
      image: 'https://public.readdy.ai/ai/img_res/3c07d743fb429f57cd004d64848d544f.jpg'
    },
    {
      id: 2,
      title: '私人展厅',
      subtitle: '专属的艺术鉴赏空间',
      description: '为尊贵客户提供私密的鉴赏环境，在优雅的氛围中感受珠宝艺术的魅力。',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20private%20jewelry%20viewing%20room%20with%20elegant%20display%20cases%2C%20soft%20pink%20blue%20and%20teal%20ambient%20lighting%2C%20contemporary%20gallery%20interior%20design%2C%20exclusive%20boutique%20atmosphere&width=600&height=400&seq=private-room&orientation=landscape'
    },
    {
      id: 3,
      title: '定制服务',
      subtitle: '独一无二的艺术创作',
      description: '与设计师深度合作，创造专属于您的珠宝艺术品，每一个细节都体现个人品味。',
      image: 'https://readdy.ai/api/search-image?query=Jewelry%20design%20consultation%20with%20designer%20and%20client%2C%20modern%20studio%20setting%20with%20colorful%20lighting%20accents%2C%20custom%20jewelry%20sketches%20and%20gemstones%2C%20artistic%20collaboration%20scene&width=600&height=400&seq=custom-service&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="flex space-x-2 mb-6">
              <div className="w-12 h-1 bg-pink-400"></div>
              <div className="w-12 h-1 bg-blue-400"></div>
              <div className="w-12 h-1 bg-teal-400"></div>
            </div>
          </div>
          <h2 className="text-5xl font-light text-gray-800 mb-6 tracking-wide">GALLERY EXPERIENCE</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            沉浸式的艺术体验，感受珠宝与艺术的完美融合
          </p>
        </div>

        {/* Showcase Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Gallery */}
          <div className="relative">
            <div className="aspect-w-3 aspect-h-2 rounded-lg overflow-hidden shadow-xl">
              <img
                src={showcaseItems[selectedImage].image}
                alt={showcaseItems[selectedImage].title}
                className="w-full h-96 object-cover transition-all duration-500"
              />
            </div>
            
            {/* Image Selector */}
            <div className="flex justify-center mt-6 space-x-3">
              {showcaseItems.map((item, index) => (
                <button
                  key={item.id}
                  onClick={() => setSelectedImage(index)}
                  className={`w-4 h-4 rounded-full transition-all cursor-pointer ${
                    selectedImage === index
                      ? 'bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {showcaseItems.map((item, index) => (
              <div
                key={item.id}
                className={`transition-all duration-500 ${
                  selectedImage === index ? 'opacity-100' : 'opacity-30'
                }`}
              >
                <div className="border-l-4 border-gradient-to-b from-pink-400 via-blue-400 to-teal-400 pl-6">
                  <h3 className="text-3xl font-light text-gray-800 mb-2 tracking-wide">
                    {item.title}
                  </h3>
                  <h4 className="text-lg text-gray-600 mb-4 font-light">
                    {item.subtitle}
                  </h4>
                  <p className="text-gray-600 leading-relaxed font-light mb-6">
                    {item.description}
                  </p>
                  {selectedImage === index && (
                    <Button variant="outline" size="md">
                      <span className="mr-2">了解更多</span>
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-20">
          <div className="bg-gradient-to-br from-pink-50 via-blue-50 to-teal-50 rounded-2xl p-12">
            <h3 className="text-3xl font-light text-gray-800 mb-6 tracking-wide">
              预约您的专属艺术之旅
            </h3>
            <p className="text-xl text-gray-600 mb-8 font-light max-w-2xl mx-auto">
              体验个性化的珠宝艺术服务，让我们为您打造独一无二的珠宝艺术品
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="primary" size="lg">
                <span className="mr-2">立即预约</span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-line"></i>
                </div>
              </Button>
              <Button variant="outline" size="lg">
                <span className="mr-2">在线咨询</span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-message-line"></i>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}